import api from '../baseAPIs/shopify';
import type { TikTokAuthorizeUrlResponse } from '@extTypes/tiktok/api';

/** Authorization url that reconnects `shop`; the server keeps the state until the callback. */
export const getTikTokReconnectUrl = async (shop: string): Promise<string> => {
    const response = await api.get<TikTokAuthorizeUrlResponse>('tiktok/authorizeUrl', { params: { shop } });
    return response.data.url;
};

/**
 * Sends the merchant to TikTok's authorize page for `shop`. For `_blank`, the tab is opened on the click, before
 *  the await, because popup blockers only allow it there; it is detached from this page before being navigated.
 */
export const openTikTokConnect = async (shop: string, target: '_blank' | '_parent' = '_blank'): Promise<void> => {
    const tab = target === '_blank' ? window.open('', '_blank') : null;
    try {
        const url = await getTikTokReconnectUrl(shop);
        if (tab) {
            tab.opener = null;
            tab.location.href = url;
        } else if (target === '_blank') {
            window.location.href = url;
        } else {
            window.open(url, target);
        }
    } catch (error) {
        tab?.close();
        window.captureException(error as Error);
    }
};

export const getTikTokShopName = async (shop: string): Promise<string> => {
    const response = await api.get<{ shopName: string }>('tiktok/shopName', { params: { shop } });
    return response.data.shopName;
};
